import Button from "components/Button/Button";
import { VisualAttribute } from "components/Form/VisualAttribute";
import React from "react";
import { externalLink } from "utils/link";

const ProfileData = ({ profile }) => {
  return !profile?.name ? (
    ""
  ) : (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 xs:gap-6">
      <div className="flex flex-col gap-4 xs:gap-6">
        <VisualAttribute title={"Name"}>{profile?.name}</VisualAttribute>
        <VisualAttribute title={"Phone Number"}>
          {profile?.phone}
        </VisualAttribute>
        <VisualAttribute title={"Email"}>{profile?.email}</VisualAttribute>
        <VisualAttribute isLink={true} title={"URL LinkedIn Account"}>
          <a
            className="text-wce-navy"
            href={externalLink(profile?.linkedin_url)}
            target="_blank"
            rel="noreferrer"
          >
            {profile?.linkedin_url}
          </a>
        </VisualAttribute>
      </div>
      <div className="flex flex-col gap-6">
        <VisualAttribute title={"Education"}>
          {profile?.education}
        </VisualAttribute>
        <VisualAttribute title={"Institution"}>
          {profile?.institution}
        </VisualAttribute>
        <VisualAttribute title={"Your CV"}>
          <a
            href={externalLink(profile?.cv_url)}
            target="_blank"
            rel="noreferrer"
          >
            <Button type="button" size="medium" variant="secondary" rounded>
              View CV
            </Button>
          </a>
        </VisualAttribute>
      </div>
    </div>
  );
};

export default ProfileData;
